import Common from '../../common/CommonNctv';

class InfoBox {
    constructor(){
        this.com = Common.instance;
    }

    templ(){
        return `
<a href="#" class="info-link">
    <div class="info-title"></div>
    <div class="info-more">바로가기</div>
    <div class="dots"></div>
</a>`;
    }

    update(_title, _id){
        if(!this.title ||  !this.more){
            this.title = $('.main-movie-centertype .info-title');
            this.more = $('.main-movie-centertype .info-more');
            this.aTag = $('.main-movie-centertype a.info-link');
        }
        this.title.html(_title);
        this.aTag.attr({'href': `/view?tv=${this.com.ip}&id=${_id}&from=popular`});

        TweenMax.set([this.title, this.more], {css:{opacity: 0, y: (window.innerWidth < 960)? 15: 50}});
        TweenMax.staggerTo([this.title, this.more], 4, {css:{opacity:1, y:0}, ease:Expo.easeOut}, 0.4);
    }

} // end of class
export default InfoBox;